import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AppError } from '../interfaces/app-error';
import { MatSidenav } from '@angular/material';

@Injectable()
export class AppStateService {

  // Observable string sources
  // private sidebarOpened = false;
  // private sidebarStatusOpen = new BehaviorSubject<boolean>(false);
  // public sidebarStatusOpen$ = this.sidebarStatusOpen.asObservable();

  public sidenav: MatSidenav;

  private errorStatus = new BehaviorSubject<AppError>(null);
  public errorStatus$ = this.errorStatus.asObservable();

  public confirmDialog = (data: any): Promise<any> => Promise.resolve(); // Function
  public infoDialog = (data: any): Promise<any> => Promise.resolve(); // Function

  constructor() { }

  public toggleSideBar(newStatus?: boolean) {
    // console.log('Toggle sidebar invoked new status: ', newStatus);
    // if (typeof newStatus === 'boolean') {
    //   console.log('newStatus is boolean');
    //   this.sidebarStatusOpen.next(newStatus);
    // } else {
    //   console.log('newStatus is not boolean. Current SB status is ', this.sidebarStatusOpen.value);
    //   const status = !this.sidebarStatusOpen.value;
    //   console.log('change status to: ', status);
    //   this.sidebarStatusOpen.next(status);
    // }

    if (this.sidenav) {
      this.sidenav.toggle(newStatus);
    } else {
      console.log('Sidenav undefined');
    }
  }

  public showError(newError: AppError) {
    this.errorStatus.next(newError);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/app-state.service.ts